import { useServices } from "@core/servicesContext";
import { AsyncResult, PromiseResult, usePromise, useStoredData } from "@utils/hooks";
import { Filter } from "./filter";

export function useMyFilters(): PromiseResult<Filter[]> {
	const { filterService } = useServices();

	return usePromise(() => filterService.list(), []);
}

export function useFilterByUserSlug(userSlug: string): AsyncResult<Filter> {
	const { filterService } = useServices();
	return useStoredData(userSlug, filterService.filterByUserSlugStore, []);
}
